
import { trackingInit, webTrack} from '@glority/tracking-js-sdk';
import {COUNTRY_API, COUNTRY_STAGE_API, isProd, TRACKING_STAGE_API, TRACKING_PROD_API} from "../config/config";
import {
    COUNTRY_CODE, 
    MODE, 
    REFERRERS, 
    GCLID, 
    MARKETING_EMAIL_ID, 
    EMAIL_COUPON_CODE, 
    FROM_EMAIL_DATE,
    SURVEY_FROM
} from "../const/LocalStorage";
import {caloDebugLog} from "../utils/debug";
import {User} from "../domin/pay/User";
import {getFromType, getAdInfo} from "./adTracking";
// Import initExternalTracking to ensure external tracking is auto-initialized
// (The import itself triggers the auto-initialization code in external.jsx)
import "../tracking/external";

export class Tracking{
    
    constructor(language) {
        this.product = "calo";
        this.language = language;
        if (isProd()) {
            window.INSTALL_ENV = "prod";
        } else {
            window.INSTALL_ENV = "stage";
        }
        this.initLogEvent();
    }
    countryApi () {
        if (isProd()) {
            return COUNTRY_API;
        } else {
            return COUNTRY_STAGE_API;
        }
    }
    initLogEvent () {
        const countryCode = localStorage.getItem(COUNTRY_CODE);

        let stageHost = TRACKING_STAGE_API;
        let prodHost = TRACKING_PROD_API;
        let useIframeForCrossOrigin = false;//需要支持非iframe方式发送请求，因为iframe无法知道是否发送成功，导致数据丢失
        trackingInit(this.product, this.language, "US", stageHost, prodHost, useIframeForCrossOrigin);

        if (!countryCode) {
            fetch(this.countryApi(), {
                method: 'GET',
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json(); // 解析 JSON 响应体
                })
                .then(result => {
                    if (result.result === 1 && result.response && result.response.country) {
                        localStorage.setItem(COUNTRY_CODE, result.response.country);
                    }
                })
                .catch(error => {
                    console.error("Error fetching country data:", error); // 打印错误以便调试
                });
        }
    }

    // Parameter mapping:
    // string4: gclid
    // id: userid
    // mode: survey_memo
    // source: referrers
    // target: ad_info (JSON string)
    // from: survey_from
    // string5: country_code
    // group: email
    // content: extended info including ad_info, search, pathname, ua, etc.
    logEvent (eventName, feedbackParams = {}, prefix = "", instantly = false) {
        let name = eventName;
        if (prefix) {
            name = `${prefix}_${eventName}`;
        }
        
        // Get URL parameters
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        
        // gclid (string4)
        const gclid = urlParams.get("gclid") || window.gclid || localStorage.getItem(GCLID);
        if (gclid && gclid.length > 0) {
            feedbackParams.string4 = gclid;
        }
        
        // 用户ID (id)
        const user = new User();
        const userid = user.getUserId();
        if (userid) {
            feedbackParams.id = userid;
        }
        
        // survey_memo (mode)
        if (!feedbackParams.mode) {
            let mode = localStorage.getItem(MODE) || "";
            feedbackParams.mode = mode;
        }
        
        // referrers (source)
        let referrersJson = localStorage.getItem(REFERRERS);
        let referrers;
        try {
            referrers = referrersJson ? JSON.parse(referrersJson) : [];
        } catch (e) {
            referrers = [];
        }
        feedbackParams.source = JSON.stringify(referrers);
        
        // ad_info
        const sourceKey = getFromType();
        const adInfo = getAdInfo();
        
        // target (ad_info)
        feedbackParams.target = adInfo;
        
        // content参数处理
        if (feedbackParams.content == "null" || feedbackParams.content == "undefined") {
            feedbackParams.content = {};
        }
        if (!feedbackParams.content) {
            feedbackParams.content = {};
        } else if (typeof feedbackParams.content === "string") {
            feedbackParams.content = {
                content: feedbackParams.content,
            };
        }
        feedbackParams.content.search = window.location.search || "";
        feedbackParams.content.pathname = window.location.pathname || "";
        feedbackParams.content.ua = navigator.userAgent || "";
        feedbackParams.content.marketing_email_id = localStorage.getItem(MARKETING_EMAIL_ID) || "";
        feedbackParams.content.email_coupon_code = localStorage.getItem(EMAIL_COUPON_CODE) || "";
        
        // Add ad_info to content
        try {
            feedbackParams.content.ad_info = adInfo ? JSON.parse(adInfo) : adInfo;
        } catch (e) {
            feedbackParams.content.ad_info = adInfo;
        }
        
        // from (survey_from)
        let from = sourceKey || localStorage.getItem(SURVEY_FROM);
        if (
            (!feedbackParams.from || feedbackParams.from.length === 0) &&
            from &&
            from.length > 0
        ) {
            feedbackParams.from = from;
        }
        
        // country_code (string5)
        feedbackParams.string5 = localStorage.getItem(COUNTRY_CODE) || "";
        
        // email from group
        if (!feedbackParams.group || feedbackParams.group.length === 0) {
            const fromEmailDate = localStorage.getItem(FROM_EMAIL_DATE);
            if (fromEmailDate && fromEmailDate.length > 0 && new Date().getTime() - parseInt(fromEmailDate) < 1000 * 60 * 60 * 24) {
                feedbackParams.group = "email";
            }
            feedbackParams.content.click_email_date = fromEmailDate ? new Date(parseInt(fromEmailDate)).toISOString() : "";
        }
        
        let data = {
            event_name: name,
        };
        Object.keys(feedbackParams).forEach(function (key) {
            data[key] = feedbackParams[key];
        });
        if (instantly) {
            webTrack(data, 1);
          } else {
            webTrack(data, 5);
          }
        
        // Create a copy for logging without content field
        const logData = {...data};
        delete logData.content;
        caloDebugLog("tracking" + JSON.stringify(logData), logData);
    }
    logEventInstantly (eventName, feedbackParams = {}, prefix = "") {
        this.logEvent(eventName, feedbackParams, prefix, true);
    }

}

export const logEvent = (eventName, feedbackParams = {}, prefix = "", instantly = false) => {
    const tracking = new Tracking("en");
    tracking.logEvent(eventName, feedbackParams, prefix, instantly);
};
